<qwyk-shipment-containers-list
    [dateFormat]="dateFormat$ | async"
    [loading]="loading$ | async"
    [shipmentContainers]="shipmentContainers$ | async"
    headerClass="p-lg-4"
    headingClass="font-weight-normal"/>
